export const GOOGLE_MAPS_API_KEY = window._env_.GOOGLE_MAPS_API_KEY;
export const AUTH_API_URL = window._env_.AUTH_API_URL;
export const PAY_AUDIT_API_URL = window._env_.PAY_AUDIT_API_URL;
export const CALENDAR_API_URL = window._env_.CALENDAR_API_URL;
export const AUTH_API_GATEWAY_URL = window._env_.AUTH_API_GATEWAY_URL;
export const LEDGER_API_URL = window._env_.LEDGER_API_URL;
export const CATALOG_API_URL = window._env_.CATALOG_API_URL;
export const API_QUOTE_URL = window._env_.API_QUOTE_URL;
export const API_LITE_URL = window._env_.API_LITE_URL;
export const APP_URL = window._env_.APP_URL;
export const SPEND_URL = window._env_.SPEND_URL;
export const BUDGET_URL = window._env_.BUDGETS_URL;
export const PROCUREMENT_URL = window._env_.PROCUREMENT_URL;
export const TAX_URL = window._env_.TAX_URL;
export const QUOTE_URL = window._env_.QUOTES_URL;
export const ACCOUNTS_RECEIVABLE_URL = window._env_.ACCOUNTS_RECEIVABLE_URL;
export const PRIVACY_POLICY_URL = window._env_.PRIVACY_POLICY_URL;
export const STORAGE_URL = window._env_.STORAGE_URL;
export const SCHEDULER_URL = window._env_.SCHEDULER_URL;
export const PAY_URL = window._env_.PAY_URL;
export const GUIDES_URL = window._env_.GUIDES_URL;
export const WRIGHT_URL = window._env_.WRIGHT_URL;
export const WRIGHT_API_URL = window._env_.WRIGHT_API_URL;
export const SENTRY_DSN = window._env_.SENTRY_DSN;
export const SENTRY_ENVIRONMENT = window._env_.SENTRY_ENVIRONMENT;
export const SENTRY_DSN_SPEND = window._env_.SENTRY_DSN_SPEND;
export const SENTRY_DSN_QUOTE = window._env_.SENTRY_DSN_QUOTE;
export const SENTRY_DSN_BUDGET = window._env_.SENTRY_DSN_BUDGET;
export const SENTRY_DSN_TAX = window._env_.SENTRY_DSN_TAX;
export const SENTRY_DSN_CONVERSATIONS = window._env_.SENTRY_DSN_CONVERSATIONS;
export const SENTRY_DSN_PROCUREMENT = window._env_.SENTRY_DSN_PROCUREMENT;
export const SENTRY_DSN_ACCOUNTS_RECEIVABLE = window._env_.SENTRY_DSN_ACCOUNTS_RECEIVABLE;
export const SENTRY_DSN_STORAGE = window._env_.SENTRY_DSN_STORAGE;
export const SENTRY_DSN_PAY = window._env_.SENTRY_DSN_PAY;
export const SENTRY_DSN_GUIDES = window._env_.SENTRY_DSN_GUIDES;
export const SENTRY_DSN_WRIGHT = window._env_.SENTRY_DSN_WRIGHT;
export const PROJECT_ID = window._env_.PROJECT_ID;
export const CLIENT_ID = window._env_.CLIENT_ID;
export const ZITADEL_API_URL = window._env_.ZITADEL_API_URL;
export const IS_PROD_ENVIRONMENT = window.location.hostname.includes('mysky.com');
